import { checkTimeordate } from '../types'
import mtz from '../utils/mtz'

const makeDifferenceInCalendarDays = (context = {}) => {
  const { timezone } = context

  const differenceInCalendarDays = (later, earlier) => {
    checkTimeordate(later)
    checkTimeordate(earlier)

    const laterDay = mtz(later, timezone).startOf('day')
    const earlierDay = mtz(earlier, timezone).startOf('day')
    return laterDay.diff(earlierDay, 'days')
  }

  return differenceInCalendarDays
}

export default makeDifferenceInCalendarDays
